import styles from "./chatProgressBar.module.scss";
import React from "react";

export default function ChatProgressBar() {
  return (
    <>
      <div className={styles.progress} >
        <div className={`${styles.progressbar} ${styles.progressbarstriped}`}
          style={{width:'100%'}}><span>Processing uploaded file…</span></div>
      </div>

    </>
  );
};
